export const starterEmailTemplate = {
  name: "Roofing website introduction",
  subject: "A website concept for {{companyName}}",
  cc: "",
  bcc: "",
  body: "Hi {{contactName}},\n\nI created a personalized roofing website concept for {{companyName}} in {{city}}. You can view it here:\n\n{{previewUrl}}\n\nI would be happy to walk you through the idea and show you how it can help generate more local estimate requests.\n\nBest regards,\n{{senderName}}"
};

export const adsEmailTemplate = {
  name: "Facebook / Meta / Google Ads",
  subject: "Measurable advertising growth for {{companyName}}",
  cc: "",
  bcc: "rico@markenbreit.com",
  body: "Hi {{contactName}},\n\nFollowing up on our conversation, MarkenGroup can help {{companyName}} plan and manage targeted campaigns across Google, Facebook, and Instagram.\n\nAs Google and Meta partners, we manage campaigns end to end — from strategy and media buying to ad copy, graphics, and the campaign assets needed to convert attention into qualified inquiries.\n\nOur proprietary tracking system shows exactly where clicks originate and which campaigns and individual ads generate real leads. This gives you a clear view of what is working and where your advertising budget produces results.\n\nWe would be happy to review your current setup and outline an initial campaign approach for {{companyName}}.\n\nBest regards,\n{{senderName}}"
};

export const builtInEmailTemplate = { id: "built-in", builtIn: true, ...starterEmailTemplate };
export const builtInEmailTemplates = [
  builtInEmailTemplate,
  { id: "built-in-ads", builtIn: true, ...adsEmailTemplate }
];

export function mergeEmailTemplates(savedTemplates = []) {
  const savedById = new Map(savedTemplates.map((template) => [template.id, template]));
  const systemIds = new Set(builtInEmailTemplates.map((template) => template.id));
  const systems = builtInEmailTemplates.map((template) => ({
    ...template,
    ...(savedById.get(template.id) || {}),
    id: template.id,
    builtIn: true
  }));
  return [...systems, ...savedTemplates.filter((template) => !systemIds.has(template.id))];
}
